import { useMemo, useState } from 'react'

const TEXT = {
  SUCCESS: 'Copied',
  FAILED: 'Failed to copy'
}

const DEFAULT_INTERVAL = 3 * 1000

const useClipboard = ({ timeout = DEFAULT_INTERVAL, defaultText }) => {
  const [copied, setCopied] = useState(null)

  const [timeoutIndex, setTimeoutIndex] = useState(null)

  const copy = async (text) => {
    clearTimeout(timeoutIndex)

    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
    } catch {
      setCopied(false)
    } finally {
      const i = setTimeout(() => {
        setCopied(null)
      }, timeout)
      setTimeoutIndex(i)
    }
  }

  const text = useMemo(() => {
    if (copied === true) {
      return TEXT.SUCCESS
    } else if (copied === false) {
      return TEXT.FAILED
    } else {
      return defaultText
    }
  }, [copied, defaultText])

  return {
    copy,
    text
  }
}

export default useClipboard
